import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Profile.css";

export default function Profile() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    // 🔁 Refresh token helper
    const tryRefreshToken = async () => {
        try {
            const res = await fetch("http://localhost:4000/api/refresh-token", {
                method: "POST",
                credentials: "include", // Send httpOnly cookie
            });

            const data = await res.json();
            if (!res.ok) throw new Error("Refresh failed");

            localStorage.setItem("token", data.token);
            return data.token;
        } catch (err) {
            console.error("Refresh token error:", err);
            return null;
        }
    };

    useEffect(() => {
        const token = localStorage.getItem("token");

        if (!token) {
            navigate("/login");
            return;
        }

        const fetchProfile = async () => {
            let currentToken = token;

            try {
                let res = await fetch("http://localhost:4000/api/profile", {
                    headers: {
                        Authorization: `Bearer ${currentToken}`,
                    },
                });

                // 🔁 Try refresh token if access token failed
                if (res.status === 401 || res.status === 403) {
                    const newToken = await tryRefreshToken();

                    if (!newToken) {
                        // 🚪 If refresh also fails, log out
                        localStorage.setItem("logoutReason", "Session expired. Please log in again.");
                        localStorage.removeItem("token");
                        localStorage.removeItem("user");
                        navigate("/login");
                        return;
                    }

                    currentToken = newToken;
                    res = await fetch("http://localhost:4000/api/profile", {
                        headers: {
                            Authorization: `Bearer ${currentToken}`,
                        },
                    });
                }

                const data = await res.json();
                if (!res.ok) throw new Error(data.message || "Failed to load profile");

                setUser(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchProfile();
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        navigate("/login");
    };

    if (loading) return <div className="profile-page">Loading...</div>;
    if (error) return <div className="profile-page error-msg">{error}</div>;

    return (
        <div className="profile-page">
            <h2>👤 My Profile</h2>
            <div className="profile-card">
                <p><strong>Name:</strong> {user.firstName} {user.lastName}</p>
                <p><strong>Email:</strong> {user.email}</p>
                <p><strong>Loyalty Points:</strong> {user.points}</p>
                <button className="logout-button" onClick={handleLogout}>Log Out</button>
            </div>
        </div>
    );
}